import axios from 'axios'
import { urls } from './urls'
import replaceParameters from '@/shahrzad-assets/shared-utils/replaceParameters'
import { ICampaignList } from '../shared-models/Fava.types'

const favaAuthApiKey = "NrCaNyQBaEqUOusV0wDDuZDz6zKpbACpNsXz07MK5kI.apigateway.tehran.ir"

let onGoingRefresh = false;
export const updateAccessToken = ({ refreshToken }: any) => {
  if(onGoingRefresh) throw new axios.Cancel("there is refresh process ongoing")
  onGoingRefresh = true;
  const res = axios.post(urls.REFRESH_TOKEN, {
    refreshToken,
    apiKey: favaAuthApiKey,
  });
  onGoingRefresh = false;
  return res;
}

//Vehicle
export const getVehicleList = ({
  pageNumber,
  pageSize,
}: {
  pageNumber: number
  pageSize: number
}): Promise<any> => {
  return axios.get(urls.VEHICLE_LIST, {
    params: { pageNumber: pageNumber, pageSize: pageSize },
  })
}

export const getVehicleInformation = ({
  vehicleId,
}: {
  vehicleId: number
}): Promise<any> => {
  return axios.get(urls.CAR_DETAIL + vehicleId)
}

export const submitVehicle = (body: any): Promise<any> => {
  return axios.post(urls.SUBMIT_VEHICLE, body)
}

export const getPalteAlphabet = (): Promise<any> => {
  return axios.get(urls.PLATE_ALPHABET)
}

export const deleteVehicle = (id: number): Promise<any> => {
  const newUrl = urls.DELETE_CAR + `/${id}`
  return axios.delete(newUrl)
}

export const getTrafficBookingCalender = (plateNo: number): Promise<any> => {
  return axios.get(replaceParameters(urls.PLAN_RESERVATION, { plateNo }))
}

//Wallet
export const getBalance = () => {
  return axios.get(urls.GET_BALANCE)
}

export const walletTransactions = ({ body }: { body: any }) => {
  return axios.post(urls.WALLET_TRANSACTIONS, body)
}

//Shahrzad
export const getBanners = ({ type }: { type: string }) => {
  return axios.get(urls.BANNERS, { params: { type: type } })
}

export const getApptilesNested = () => {
  return axios.get(urls.APP_TILES_NESTED)
}

export const getUserTotalPoints = () => {
  return axios.get(urls.USER_TOTAL_POINTS)
}

//Debt
export const getTrafficRecords = ({
  plateNo,
  pageNumber,
  pageSize,
}: {
  plateNo: number
  pageNumber: number
  pageSize: number
}): Promise<any> => {
  return axios.get(replaceParameters(urls.TRAFFIC_RECORDS, { plateNo }), {
    params: { pageNumber: pageNumber, pageSize: pageSize },
  })
}

export const postDebtPay = ({
  plateNo,
  billId,
}: {
  plateNo: number
  billId: number
}): Promise<any> => {
  return axios.post(replaceParameters(urls.DEBT_PAY, { plateNo, billId }), {})
}

//register verify
export const registerVerfiy = ({
  mobileNo,
  otpCode,
  ...params
}: {
  mobileNo: string
  otpCode: string
  [key: string]: string
}) => {
  return axios.post(urls.REGISTER_VERIFY, {
    mobileNo,
    otpCode,
    apiKey: favaAuthApiKey,
    ...params,
  })
}

//Base
export const loginOrRegister = ({
  phoneNumber,
  ...params
}: {
  phoneNumber: string
}) => {
  return axios.post(urls.LOGIN_OR_REGISTER, {
    mobileNo: phoneNumber,
    ...params,
  })
}

// login
export const login = ({
  username,
  password,
  ...params
}: {
  username: string
  password: string
}) => {
  return axios.post(urls.LOGIN, {
    username: username,
    password: password,
    apiKey: favaAuthApiKey,
    ...params,
  })
}

export const loginOtp = ({ phoneNumber }: { phoneNumber: string }) => {
  return axios.post(urls.LOGIN_OTP, { phoneNumber: phoneNumber, type: 1 })
}

//register level 2
export const upgradeUserLevel = ({
  nationalCode,
  birthDate,
  ...params
}: {
  nationalCode: string
  birthDate: string
  [key: string]: string
}) => {
  return axios.post(urls.UPGRADE_USER_LEVEL, {
    nationalCode,
    birthDate,
    ...params,
  })
}

export const verifyRegisterLevel2 = async (
  traceNo: string,
  otpCode: string,
  nonce: string,
) => {
  return axios.post(urls.VERIFY_REGISTER_LEVEL2, { traceNo, otpCode, nonce })
}

export const decodeToken = () => {
  return axios.get(urls.DECODE_TOKEN)
}

// wallet

export const cashOut = (body) => {
  return axios.post(urls.CASH_OUT, body)
}

export const getTerminals = () => {
  return axios.get(urls.TERMINALS)
}

export const userCampaign = ({
  terminalId,
  amount,
}: {
  terminalId: number
  amount: number
}): Promise<ICampaignList> => {
  return axios.get(
    replaceParameters(urls.USER_CAMPAIGN, {
      terminalId: terminalId,
      amount: amount,
    }),
  )
}

//payment
export const increaseAmount = ({ amount }: { amount: number }) => {
  return axios.post(urls.INCREASE_AMOUNT, { amount: amount })
}

//fava
export const campaign = () => {
  return axios.get(urls.CAMPAIGN)
}

// push notif
export const pushNotificationVerifyAccount = (body) => {
  return axios.post(urls.PUSH_NOTIFICATION_VERIFY_ACCOUNT, body)
}

export const pushNotificationUnVerifyAccount = (body) => {
  return axios.post(urls.PUSH_NOTIFICATION_UNVERIFY_ACCOUNT, body)
}

export const cancelPushNotif = () => {
  return axios.post(urls.CANCEL_SUBSCRIPTION)
}

export const getAppTiles = () => {
  return axios.get(urls.APP_TILES)
}

//club
export const userActivity = ({ body }: { body: any }) => {
  return axios.post(urls.USER_ACTIVITY, body)
}
//referral
export const postReferralCode = (body) => {
  return axios.post(urls.REFER_CODE, body)
}

//Locatin
export const getExactLocation = ({
  lat,
  lng,
  buffer,
}: {
  lat: number
  lng: number
  buffer: number
}) => {
  return axios.get(urls.GET_LOCATION, {
    params: { x: lng, y: lat, buffer: buffer },
  })
}
